/* PSC — Presidents Cup Sale. Self-guarding, idempotent. */
(function(){
  if (window.__pscInit) return; window.__pscInit = true;

  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  ready(function(){
    /* ---- Reveal on scroll. Fails OPEN: if anything goes wrong, content shows.
       The original page stranded large blank regions when scrolled fast. ---- */
    var targets = document.querySelectorAll('.psc [data-reveal]');
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function(el){ el.classList.add('is-in'); });
    } else {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(e){
          if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      targets.forEach(function(el){
        // Anything already in view on load is shown immediately, no animation lag.
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight) { el.classList.add('is-in'); } else { io.observe(el); }
      });
      // Safety net: never leave content hidden.
      setTimeout(function(){ targets.forEach(function(el){ el.classList.add('is-in'); }); }, 4000);
    }

    /* ---- Stat bars animate to their data-pct width ---- */
    var bars = document.querySelectorAll('.psc-stat__fill[data-pct]');
    function fill(el){ el.style.width = Math.max(0, Math.min(100, parseFloat(el.dataset.pct) || 0)) + '%'; }
    if (!('IntersectionObserver' in window)) { bars.forEach(fill); }
    else {
      var bo = new IntersectionObserver(function(es){
        es.forEach(function(e){ if (e.isIntersecting){ fill(e.target); bo.unobserve(e.target); } });
      }, { threshold: 0.3 });
      bars.forEach(function(b){ bo.observe(b); });
      setTimeout(function(){ bars.forEach(fill); }, 4000);
    }

    /* ---- Buy-box gallery: slide transition + swipe ---- */
    document.querySelectorAll('[data-psc-gallery]').forEach(function(g){
      var frame = g.querySelector('.psc-buy__main');
      var main  = g.querySelector('[data-psc-main]');
      var thumbs = [].slice.call(g.querySelectorAll('[data-psc-thumb]'));
      if (!frame || !main || !thumbs.length) return;
      var cur = Math.max(0, thumbs.findIndex(function(t){ return t.classList.contains('active'); }));
      var busy = false;
      var EASE = 'transform .42s cubic-bezier(.22,.61,.36,1)';
      function mark(n){ thumbs.forEach(function(t,i){ t.classList.toggle('active', i===n); }); }
      function goTo(n){
        n = (n + thumbs.length) % thumbs.length;
        if (busy || n === cur) return;
        var src = thumbs[n].getAttribute('data-src'); if (!src) return;
        var dir = n > cur ? 1 : -1;
        busy = true;
        var next = document.createElement('img');
        next.alt = main.alt; next.decoding = 'async';
        next.style.transition = 'none';
        next.style.transform = 'translateX(' + (dir*100) + '%)';
        frame.insertBefore(next, main.nextSibling);
        var go = function(){
          requestAnimationFrame(function(){ requestAnimationFrame(function(){
            main.style.transition = EASE; next.style.transition = EASE;
            main.style.transform = 'translateX(' + (-dir*100) + '%)';
            next.style.transform = 'translateX(0)';
          }); });
          setTimeout(function(){
            main.src = src;
            main.style.transition = 'none'; main.style.transform = '';
            next.remove(); cur = n; busy = false;
          }, 450);
        };
        next.onload = go; next.onerror = go; next.src = src;
        mark(n);
      }
      thumbs.forEach(function(t,i){ t.addEventListener('click', function(){ goTo(i); }); });
      g.__pscGoTo = goTo;
      // swipe
      var x0 = null;
      frame.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, {passive:true});
      frame.addEventListener('touchend', function(e){
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) goTo(cur + (dx < 0 ? 1 : -1));
      }, {passive:true});
      var p = g.querySelector('[data-psc-gal-prev]'), nx = g.querySelector('[data-psc-gal-next]');
      if (p)  p.addEventListener('click', function(){ goTo(cur - 1); });
      if (nx) nx.addEventListener('click', function(){ goTo(cur + 1); });
    });

    /* ---- Rail dots track the scroll position ---- */
    document.querySelectorAll('[data-psc-rail]').forEach(function(rail){
      var wrap = rail.closest('.psc-panel') || rail.parentElement;
      var dots = wrap ? wrap.querySelector('[data-psc-dots]') : null;
      if (!dots) return;
      var buttons = [].slice.call(dots.children);
      var cards = [].slice.call(rail.children);
      if (!cards.length) return;
      function sync(){
        var mid = rail.scrollLeft + rail.clientWidth / 2, best = 0, bestD = Infinity;
        cards.forEach(function(c, i){ var d = Math.abs((c.offsetLeft + c.offsetWidth / 2) - mid); if (d < bestD){ bestD = d; best = i; } });
        buttons.forEach(function(b, i){ b.classList.toggle('is-on', i === best); });
      }
      rail.addEventListener('scroll', function(){ clearTimeout(rail.__t); rail.__t = setTimeout(sync, 60); });
      buttons.forEach(function(b, i){ b.addEventListener('click', function(){ if (cards[i]) rail.scrollTo({ left: cards[i].offsetLeft - rail.offsetLeft, behavior: 'smooth' }); }); });
      sync();
    });

    /* ---- Social clips: a click plays WITH SOUND, fullscreen.
       Desktop/Android: Fullscreen API. iPhone: dropping `playsinline` makes
       Safari open its own fullscreen player on play(), which is the only
       dependable route there (webkitEnterFullscreen throws before metadata). ---- */
    function fsEl(){ return document.fullscreenElement || document.webkitFullscreenElement || null; }
    var socialCards = [].slice.call(document.querySelectorAll('.psc-social__card'));
    function resetCard(card){
      var v = card.querySelector('video'); if (!v) return;
      v.pause(); v.muted = true; v.controls = false; v.setAttribute('playsinline','');
      card.classList.remove('is-playing');
    }
    socialCards.forEach(function(card){
      var v = card.querySelector('video[data-psc-video]');
      var btn = card.querySelector('.psc-social__play');
      if (!v) return;
      function open(){
        socialCards.forEach(function(o){ if (o !== card && o.classList.contains('is-playing')) resetCard(o); });
        var canFs = !!(v.requestFullscreen || v.webkitRequestFullscreen);
        v.preload = 'auto';
        v.muted = false; v.defaultMuted = false; v.removeAttribute('muted'); v.volume = 1;
        v.controls = true;
        if (!canFs) v.removeAttribute('playsinline');          // iPhone: native fullscreen player
        card.classList.add('is-playing');
        var pr = v.play(); if (pr && pr.catch) pr.catch(function(){});
        try {
          if (v.requestFullscreen){ var r = v.requestFullscreen(); if (r && r.catch) r.catch(function(){}); }
          else if (v.webkitRequestFullscreen){ v.webkitRequestFullscreen(); }
        } catch(e){}
      }
      if (btn) btn.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); open(); });
      v.addEventListener('click', function(e){ if (!fsEl() && !card.classList.contains('is-playing')){ e.preventDefault(); open(); } });
      v.addEventListener('webkitendfullscreen', function(){ resetCard(card); });
    });
    function onFsChange(){ if (!fsEl()) socialCards.forEach(function(c){ if (c.classList.contains('is-playing')) resetCard(c); }); }
    document.addEventListener('fullscreenchange', onFsChange);
    document.addEventListener('webkitfullscreenchange', onFsChange);

    /* ---- Before / after slider ---- */
    document.querySelectorAll('[data-psc-ba]').forEach(function(frame){
      var range = frame.querySelector('.psc-ba__range');
      if (!range) return;
      function set(){ frame.style.setProperty('--psc-ba', range.value + '%'); }
      range.addEventListener('input', set);
      set();
    });

    /* ---- FAQ: animated open/close, one at a time ---- */
    document.querySelectorAll('.psc-faq').forEach(function(list){
      var items = [].slice.call(list.querySelectorAll('details.psc-faq__item'));
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var T = 'height .3s cubic-bezier(.22,.61,.36,1), opacity .22s ease, padding-bottom .3s cubic-bezier(.22,.61,.36,1)';
      function body(d){ return d.querySelector('.psc-faq__a'); }
      function clear(a){ a.style.height=''; a.style.opacity=''; a.style.overflow=''; a.style.transition=''; a.style.paddingBottom=''; }
      function close(d){
        var a = body(d); if (!d.open || !a) return;
        if (reduce){ d.open = false; return; }
        d.classList.add('is-closing');
        a.style.overflow = 'hidden'; a.style.height = a.offsetHeight + 'px';
        requestAnimationFrame(function(){ a.style.transition = T; a.style.height = '0px'; a.style.opacity = '0'; a.style.paddingBottom = '0px'; });
        setTimeout(function(){ d.open = false; d.classList.remove('is-closing'); clear(a); }, 310);
      }
      function open(d){
        var a = body(d); if (!a) return;
        d.open = true; if (reduce) return;
        var h = a.offsetHeight, pb = getComputedStyle(a).paddingBottom;
        a.style.overflow = 'hidden'; a.style.height = '0px'; a.style.opacity = '0'; a.style.paddingBottom = '0px';
        requestAnimationFrame(function(){ requestAnimationFrame(function(){ a.style.transition = T; a.style.height = h + 'px'; a.style.opacity = '1'; a.style.paddingBottom = pb; }); });
        setTimeout(function(){ clear(a); }, 330);
      }
      items.forEach(function(d){
        d.removeAttribute('name');                         // JS owns exclusivity so closing can animate
        var sm = d.querySelector('summary'); if (!sm) return;
        sm.addEventListener('click', function(e){
          e.preventDefault();
          if (d.open && !d.classList.contains('is-closing')){ close(d); }
          else { items.forEach(function(o){ if (o !== d) close(o); }); open(d); }
        });
      });
    });

    /* ---- Sticky bar: on once the hero button has scrolled away, off while the
       closing buy box is on screen. Plain scroll maths — IntersectionObserver
       does not fire in throttled / background tabs. ---- */
    document.querySelectorAll('[data-psc-sticky]').forEach(function(bar){
      var top = document.querySelector('#psc-buy .psc-buy__form') || document.querySelector('#psc-buy');
      var bottom = document.querySelector('#psc-buy-bottom .psc-buy__content') || document.querySelector('#psc-buy-bottom');
      if (!top) return;
      function sync(){
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var pastTop = top.getBoundingClientRect().bottom < 0;
        var atBottom = false;
        if (bottom){ var r = bottom.getBoundingClientRect(); atBottom = r.top < vh - 80 && r.bottom > 0; }
        var on = pastTop && !atBottom;
        if (on !== bar.classList.contains('is-on')){ bar.classList.toggle('is-on', on); bar.setAttribute('aria-hidden', on ? 'false' : 'true'); }
      }
      window.addEventListener('scroll', sync, {passive:true});
      window.addEventListener('resize', sync);
      sync();
    });

    /* ---- Countdown: only runs when an ISO end date is supplied. ---- */
    document.querySelectorAll('[data-psc-countdown]').forEach(function(c){
      var end = Date.parse(c.getAttribute('data-psc-countdown'));
      if (isNaN(end)) { c.remove(); return; }   // no honest deadline -> no fake timer
      var out = c.querySelectorAll('[data-unit]');
      function tick(){
        var d = end - Date.now();
        if (d <= 0){ c.remove(); return; }
        var v = { d: Math.floor(d/864e5), h: Math.floor(d/36e5)%24, m: Math.floor(d/6e4)%60, s: Math.floor(d/1e3)%60 };
        out.forEach(function(u){ u.textContent = String(v[u.dataset.unit]).padStart(2,'0'); });
      }
      tick(); setInterval(tick, 1000);
    });
  });
})();
